import Header from '@/components/feature/Header';
import TestimonialsSection from '@/pages/home/components/TestimonialsSection';
import Footer from '@/components/feature/Footer';

export default function TestimonialsPage() {
  return (
    <div className="min-h-screen bg-[#DBCEC5]">
      <Header />
      <div className="pt-20">
        <TestimonialsSection bookSessionHref="/#services-pricing" theme="light" />
      </div>
      <Footer />
    </div>
  );
}